import {inject, Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, combineLatestWith, Observable, Subject, takeUntil} from 'rxjs';
import {map} from 'rxjs/operators';
import {TpaSearchCoverageResExtended} from "../../../models/http/tpa-http.model";
import {TpaStatusFilter} from "../../../models/tpa.enum";
import {TpaGroupService} from "../../../services/tpa-group.service";


@Injectable({
  providedIn: 'root'
})
export class TpaDetailsStateService implements OnDestroy {
  private dataSource = new BehaviorSubject<TpaSearchCoverageResExtended[]>([]);
  private filters$ = new BehaviorSubject<{
    status: TpaStatusFilter;
    searchFilteredData: TpaSearchCoverageResExtended[] | null;
  }>({status: TpaStatusFilter.All, searchFilteredData: null});

  private tpaGroupService = inject(TpaGroupService);
  private unsubscribe$ = new Subject<void>();


  setDataSource(data: TpaSearchCoverageResExtended[]) {
    this.dataSource.next(data || []);
  }

  getDataSourceValue(): TpaSearchCoverageResExtended[] {
    return this.dataSource.getValue();
  }

  subscribeToDataSource(): Observable<TpaSearchCoverageResExtended[]> {
    return this.dataSource.pipe(
      combineLatestWith(this.filters$),
      map(([data, filters]) => {
        let filteredData = filters.searchFilteredData || [...data];

        filteredData = this.tpaGroupService.filterCensusLines(filteredData, filters.status);
        return filteredData;
      }),
      takeUntil(this.unsubscribe$)
    )
  }

  emitFilterChange(filters: { status: TpaStatusFilter, searchFilteredData: TpaSearchCoverageResExtended[] | null }) {
    this.filters$.next(filters);
  }

  getFiltersValue(): { status: TpaStatusFilter, searchFilteredData: TpaSearchCoverageResExtended[] | null } {
    return this.filters$.getValue();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


}
